

import React, { Component } from "react";
import { withRouter } from "./withRouter";
import  {  Popup } from "react-map-gl";


class TooltipIssues extends Component {
 
  
             
buildTooltip(hoverInfo, styledGeo) {
  const { geoLevel,IssueLevel } = this.props;

  if (!hoverInfo) return null;
  if (!styledGeo) return null;
  if (!IssueLevel) return null;

  const { area_name, topLabel, area_id } = hoverInfo.props;


  // NEW: predictedValues now contain { key, area_name, value, lower, upper }
  const predictedValues = JSON.parse(hoverInfo.props._allValuesSorted);

 



    
const issueConfig = {
  // National
  health_nat_p: { label: "Health", color: "#1976d2" },
  climate_nat_p: { label: "Climate", color: "#2e7d32" },
  nitrogen_nat_p: { label: "Nitrogen", color: "#6d4c41" },
  housing_nat_p: { label: "Housing", color: "#7b1fa2" },
  immigration_nat_p: { label: "Immigration", color: "#f57c00" },
  poverty_nat_p: { label: "Poverty", color: "#d32f2f" },
  purchasing_nat_p: { label: "Purchasing power", color: "#c2185b" },
  safety_nat_p: { label: "Safety", color: "#455a64" },
  education_nat_p: { label: "Education", color: "#512da8" },
  dutch_nat_p: { label: "Dutch identity/language", color: "#0288d1" },
  trust_nat_p: { label: "Trust in politics", color: "#5d4037" },
  defense_nat_p: { label: "Defence", color: "#37474f" },
  EU_nat_p: { label: "EU", color: "#1565c0" },
  staff_nat_p: { label: "Staffing", color: "#00838f" },
  other_nat_p: { label: "Other", color: "#9e9e9e" },

  // Local
  housing_local_p: { label: "Housing", color: "#7b1fa2" },
  CoL_local_p: { label: "Cost of living", color: "#c2185b" },
  traffic_local_p: { label: "Traffic", color: "#455a64" },
  publicTransport_local_p: { label: "Public transport", color: "#00838f" },
  safety_local_p: { label: "Safety", color: "#455a64" },
  health_local_p: { label: "Health", color: "#1976d2" },
  recycle_local_p: { label: "Recycling/waste", color: "#2e7d32" },
  education_local_p: { label: "Education", color: "#512da8" },
  climate_local_p: { label: "Climate", color: "#2e7d32" },
  econ_local_p: { label: "Local economy", color: "#6d4c41" },
  governance_local_p: { label: "Local governance", color: "#5d4037" },
  integration_local_p: { label: "Integration", color: "#f57c00" },
  other_local_p: { label: "Other", color: "#9e9e9e" },
}

  // helper formatting
  const fmtPct0 = (x) => (Number.isFinite(x) ? `${x.toFixed(0)}%` : "n/a");
  const fmtCI = (lwr, upr) =>
    Number.isFinite(lwr) && Number.isFinite(upr) ? ` [${lwr.toFixed(0)}%–${upr.toFixed(0)}%]` : "";

  // Build vote share lines WITH CI
  const voteLines = predictedValues.map(({ key, value, lower, upper }) => {
    const party = issueConfig[key];
    if (!party) return null;

    const predicted = Number(value); // value is the % number


    return (
      <div key={key} style={{ color: party.color }}>
        {party.label}: {fmtPct0(predicted)}
      </div>
    );
  });

  let area_type_label;
  switch (geoLevel) {
    case "geementen":
      area_type_label = "Gemeente";
      break;
    case "buurt":
      area_type_label = "Buurt";
      break;
    default:
      area_type_label = geoLevel;
      break;
  }



  return (
    <div style={{ fontSize: "13px" }}>
      <strong>{area_name}</strong> {area_type_label}
      <br />
      Lead {this.props.IssueLevel=="national"?"National":"Local"} Issue: {topLabel}
      <br />
      <br />
      {voteLines}
      <br />
      <small></small>
    </div>
  );
}







 

  render() {    
    const {  styledGeo,  hoverInfo} = this.props;

   
  return (
    <>
      {styledGeo && hoverInfo && hoverInfo?.props?.topValue>0 &&(
        <Popup
          longitude={hoverInfo.lon}
          latitude={hoverInfo.lat}
          closeButton={false}
          closeOnClick={false}
          offset={12}
          dynamicPosition={true}
          maxWidth="500px"
        >
          {this.buildTooltip(hoverInfo, styledGeo, this.props.tooltip_pastcomp)}
        </Popup>
      )}
    </>
  );
}
}
    
    export default withRouter(TooltipIssues);
    